import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ContratoCliente, ContratoClienteBusca, ContratoProdutoBusca } from '../../core/models/contratos/contrato';
import { ContratoService } from '../../core/services/contratos/contrato.service';

@Component({
  standalone: false,
  selector: 'app-contratos',
  templateUrl: './contratos.component.html',
  styleUrls: ['./contratos.component.css']
})
export class ContratosComponent implements OnInit {
  contratos: ContratoCliente[] = [];
  contrato: ContratoCliente = this.novoContrato();
  clientes: ContratoClienteBusca[] = [];
  produtos: ContratoProdutoBusca[] = [];
  termoCliente = '';
  filtroContratoCliente = '';
  termoProduto = '';
  carregando = false;
  usa_contrato = false;
  pode_configurar = false;

  constructor(
    private contratoService: ContratoService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.usa_contrato = localStorage.getItem('usa_contrato') === 'true';
    const isMaster = localStorage.getItem('is_master') === 'true';
    const isDiretor = localStorage.getItem('is_diretor') === 'true';
    this.pode_configurar = this.usa_contrato && (isMaster || isDiretor);

    if (this.pode_configurar) {
      this.carregar();
    }
  }

  get contratosFiltrados(): ContratoCliente[] {
    const filtro = (this.filtroContratoCliente || '').toLowerCase().trim();
    if (!filtro) {
      return this.contratos;
    }

    return (this.contratos || []).filter((contrato) => {
      const cliente = (contrato.cliente_nome || '').toLowerCase();
      const erp = (contrato.cliente_codigo_erp || contrato.codigo_no_erp_do_cliente || '').toLowerCase();
      return cliente.indexOf(filtro) >= 0 || erp.indexOf(filtro) >= 0;
    });
  }

  carregar() {
    this.carregando = true;
    this.contratoService.getContratos().subscribe((contratos) => {
      this.contratos = contratos || [];
      this.carregando = false;
    });
  }

  novo() {
    this.contrato = this.novoContrato();
    this.clientes = [];
    this.produtos = [];
    this.termoCliente = '';
    this.termoProduto = '';
  }

  editar(id: number) {
    this.contratoService.getContrato(id).subscribe((contrato) => {
      if (contrato) {
        contrato.data_inicio = this.formatarDataInput(contrato.data_inicio);
        contrato.data_fim = this.formatarDataInput(contrato.data_fim);
        this.contrato = contrato;
      }
    });
  }

  salvar() {
    if (!this.contrato.client_id) {
      this.toastr.warning('', 'Selecione um cliente para o contrato.');
      return;
    }

    if (!this.contrato.nome_contrato || this.contrato.nome_contrato.trim() === '') {
      this.toastr.warning('', 'Informe o nome do contrato.');
      return;
    }

    if (!this.contrato.itens || this.contrato.itens.length === 0) {
      this.toastr.warning('', 'Adicione pelo menos um produto ao contrato.');
      return;
    }

    this.contratoService.saveContrato(this.contrato).subscribe((id) => {
      if (id > 0) {
        this.toastr.success('', 'Contrato salvo com sucesso.');
        this.contrato.id = id;
        this.carregar();
      }
    });
  }

  excluir(contrato: ContratoCliente) {
    if (!contrato || !contrato.id) {
      return;
    }

    if (!confirm('Deseja inativar este contrato?')) {
      return;
    }

    this.contratoService.deleteContrato(contrato.id).subscribe((ok) => {
      if (ok) {
        this.toastr.success('', 'Contrato inativado.');
        this.novo();
        this.carregar();
      }
    });
  }

  buscarClientes() {
    if (!this.termoCliente || this.termoCliente.trim().length < 2) {
      this.toastr.info('', 'Digite pelo menos 2 caracteres para buscar.');
      return;
    }

    this.contratoService.searchClients(this.termoCliente).subscribe((clientes) => {
      this.clientes = clientes || [];
    });
  }

  selecionarCliente(cliente: ContratoClienteBusca) {
    this.contrato.client_id = cliente.id;
    this.contrato.cliente_nome = cliente.name;
    this.contrato.cliente_codigo_erp = cliente.codigo_no_erp_do_cliente;
    this.contrato.seller_id = cliente.seller_id;
    this.contrato.seller_nome = cliente.seller_nome;
    this.clientes = [];
    this.termoCliente = cliente.name;

    if (!this.contrato.nome_contrato) {
      this.contrato.nome_contrato = 'Contrato - ' + cliente.name;
    }
  }

  buscarProdutos() {
    if (!this.termoProduto || this.termoProduto.trim().length < 2) {
      this.toastr.info('', 'Digite pelo menos 2 caracteres para buscar produto.');
      return;
    }

    this.contratoService.searchProducts(this.termoProduto).subscribe((produtos) => {
      this.produtos = produtos || [];
    });
  }

  adicionarProduto(produto: ContratoProdutoBusca) {
    if (this.contrato.itens.some((item) => item.product_id === produto.id)) {
      this.toastr.info('', 'Produto ja adicionado ao contrato.');
      return;
    }

    this.contrato.itens.push({
      product_id: produto.id,
      produto_nome: produto.name,
      produto_codigo: produto.codigo,
      quantidade_objetivo_mensal: 0,
      unidade_medida: 'UN',
      ativo: true
    });

    this.produtos = [];
    this.termoProduto = produto.name;
  }

  removerProduto(index: number) {
    this.contrato.itens.splice(index, 1);
  }

  private novoContrato(): ContratoCliente {
    return {
      nome_contrato: '',
      data_inicio: this.formatarDataInput(new Date().toISOString()),
      data_fim: '',
      status: 'ATIVO',
      observacao: '',
      itens: []
    };
  }

  private formatarDataInput(data: string): string {
    if (!data) {
      return '';
    }

    return data.substring(0, 10);
  }
}
